import { c as _c } from "react/compiler-runtime";
import { NumericSelector, type NumericSelectorProps } from '@/components/app-ui/numeric-selector/NumericSelector';
export interface WippenDesignSpecificationProps {
  name: string;
  selectorProps: NumericSelectorProps;
}

/**
 * One setting of the spring design: what is being set on the left, its stepper
 * on the right.
 *
 * The row now lives inside the objective card, in a column barely wider than
 * the stepper itself, so it wraps instead of squeezing the stepper: a label
 * above its control still reads as one setting, a clipped stepper does not.
 */
export const WipenDesignSpecificationItem: React.FC<WippenDesignSpecificationProps> = t0 => {
  const $ = _c(7);
  const {
    name,
    selectorProps
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = <span className="text-sm font-semibold">{name}</span>;
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== selectorProps) {
    t2 = <NumericSelector {...selectorProps} />;
    $[2] = selectorProps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col items-start gap-2">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};